const formatEmailLink = email => `mailto:${email}`;

export default formatEmailLink;
